package nl.astraeus.wiki.view

import kotlinx.html.div
import kotlinx.html.js.onClickFunction
import nl.astraeus.css.properties.*
import nl.astraeus.css.style.Style
import nl.astraeus.komp.HtmlBuilder
import nl.astraeus.komp.Komponent
import nl.astraeus.wiki.WikiData
import nl.astraeus.wiki.css.Css
import nl.astraeus.wiki.css.Css.defineCss
import nl.astraeus.wiki.css.CssName

class MainView: Komponent(), CssName {
  val wikiHeader = WikiHeader()
  val wikiContent = WikiContent()

  val pageHeader = Header()
  val menu = Menu()
  val content = Content()
  val allPages = AllPages()

  var printWikiMode = false

  init {
    css()
  }

  override fun HtmlBuilder.render() {
    div(MainViewCss.name) {
      if (WikiData.currentWiki == null) {
        div(WikiViewCss.name) {
          div(WikiHeaderCss.name) {
            include(wikiHeader)
          }
          div(WikiContentCss.name) {
            include(wikiContent)
          }
        }
      } else {
        div(PageViewCss.name) {
          div(HeaderCss.name) {
            include(pageHeader)
          }
          div(MenuCss.name) {
            include(menu)
          }
          div(ContentCss.name) {
            if (printWikiMode) {
              include(allPages)
            } else {
              include(content)
            }
          }
        }
      }
      if (printWikiMode) {
        div(PrintingCss.name) {
          div(PrintingTitleCss.name) {
            +"Printing mode, click to continue"
          }
          onClickFunction = {
            printWikiMode = false
            requestUpdate()
          }
        }
      }
    }
  }

  object MainViewCss : CssName
  object PageViewCss : CssName
  object HeaderCss : CssName
  object MenuCss : CssName
  object ContentCss : CssName
  object WikiViewCss : CssName
  object WikiHeaderCss : CssName
  object WikiContentCss : CssName
  object AddCss : CssName
  object RemoveCss : CssName
  object HeaderButtonCss : CssName
  object PrintingCss : CssName
  object PrintingTitleCss : CssName

  private fun css() {
    defineCss {
      select("*") {
        select("*:before") {
          select("*:after") {
            boxSizing(BoxSizing.borderBox)
          }
        }
      }
      select("html", "body") {
        margin(0.px)
        padding(0.px)
        height(100.prc)
      }
      select(PrintingCss.cls()) {
        position(Position.fixed)
        bottom(0.px)
        left(0.px)
        width(100.vw)
        height(100.vh)
        display(Display.flex)
        alignItems(AlignItems.center)
        justifyContent(JustifyContent.center)
        zIndex(1000)
        backgroundColor(Css.currentStyle.mainBackgroundColor.changeAlpha(0.75))
        select(PrintingTitleCss.cls()) {
          color(Css.currentStyle.mainFontColor)
          backgroundColor(Css.currentStyle.buttonBackgroundColor.changeAlpha(0.25))
          fontSize(4.vw)
          cardCss()
          padding(2.em)
        }
      }
      select("body", "input", "select", "textarea") {
        backgroundColor(Css.currentStyle.mainBackgroundColor)
        color(Css.currentStyle.mainFontColor)

        fontFamily("Arial, 'Times new roman'")
        fontSize(16.px)
        //fontWeight(FontWeight.bold)

        //transition()
        //noTextSelect()
      }
      select(WikiViewCss.cls()) {
        display(Display.grid)
        gridTemplateAreas(
          """
          "header"
          "content"
        """.trimIndent()
        )
        gridTemplateRows(120.px, 1.fr)
        height(100.vh)
      }
      select(WikiHeaderCss.cls()) {
        gridArea("header")
        cardCss()
        marginBottom(0.px)
      }
      select(WikiContentCss.cls()) {
        gridArea("content")
        cardCss()
      }
      select(PageViewCss.cls()) {
        display(Display.grid)
        gridTemplateAreas("""
          "header header"
          "menu content"
        """.trimIndent())
        gridTemplateRows(120.px, 1.fr)
        gridTemplateColumns(450.px, 1.fr)
        height(100.vh)
      }
      select(HeaderCss.cls()) {
        gridArea("header")
        cardCss()
        marginBottom(0.px)
      }
      select(MenuCss.cls()) {
        gridArea("menu")
        cardCss()
      }
      select(ContentCss.cls()) {
        gridArea("content")
        cardCss()
        marginLeft(0.px)
      }
      select(AddCss.cls()) {
        float(CssFloat.right)
        backgroundColor(hsl(90, 50, 90))
        padding(0.15.rem, 0.5.rem)
        position(Position.relative)
        top((-0.5).rem)
        boxShadow(Css.currentStyle.buttonBoxShadow)
        borderRadius(Css.currentStyle.cardBorderRadius)

        hover {
          backgroundColor(hsl(90, 50, 80))
        }
      }
      select(RemoveCss.cls()) {
        backgroundColor(hsl(0, 50, 90))
        padding(0.15.rem, 0.5.rem)
        position(Position.relative)
        top(0.5.rem)
        float(CssFloat.right)
        boxShadow(Css.currentStyle.buttonBoxShadow)
        borderRadius(Css.currentStyle.cardBorderRadius)

        hover {
          backgroundColor(hsl(0, 50, 80))
        }
      }
      select(HeaderButtonCss.cls()) {
        top(0.px)
        height(1.rem)
        padding(0.4.rem, 0.8.rem)
      }

      media("print") {
        select(PageViewCss.cls()) {
          gridTemplateRows(0.px, 1.fr)
          gridTemplateColumns(0.px, 1.fr)
          height(100.prc)
        }

        select(HeaderCss.cls(), MenuCss.cls()) {
          display(Display.none)
        }

        select(ContentCss.cls()) {
          marginTop(0.px)
          padding(2.em)
          boxShadow(BoxShadow.none)
          border("none")
        }

        select(PrintingCss.cls(), AddCss.cls()) {
          display(Display.none)
        }
      }
    }
  }
}

fun Style.cardCss() {
  margin(Css.currentStyle.materialMargin)
  padding(1.rem)
  boxShadow(Css.currentStyle.boxShadow)
  backgroundColor(Css.currentStyle.mainBackgroundColor.lighten(100))
  borderRadius(Css.currentStyle.cardBorderRadius)
}
